/**
 * Base URL for pg-payload-cms (no trailing slash).
 * @returns {string}
 */
export function getPayloadCmsUrl() {
  const raw = process.env.REACT_APP_PAYLOAD_CMS_URL || "http://localhost:4001";
  const base = raw.split("#")[0].trim();
  return base.replace(/\/+$/, "");
}

/**
 * @param {string} path - e.g. `/api/promotions`
 * @param {Record<string, string | number | boolean | undefined>} [searchParams]
 */
export function buildPayloadApiUrl(path, searchParams = {}) {
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  const url = new URL(`${getPayloadCmsUrl()}${normalizedPath}`);

  Object.entries(searchParams).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      url.searchParams.set(key, String(value));
    }
  });

  return url.toString();
}

/**
 * @param {string} url
 * @param {RequestInit} [init]
 */
export async function payloadFetch(url, init = {}) {
  const response = await fetch(url, {
    ...init,
    headers: {
      Accept: "application/json",
      ...init.headers,
    },
  });

  if (!response.ok) {
    let message = `Payload API error (${response.status})`;
    try {
      const body = await response.json();
      if (body?.message) message = body.message;
      else if (body?.errors?.[0]?.message) message = body.errors[0].message;
    } catch {
      // ignore JSON parse errors
    }
    throw new Error(message);
  }

  return response.json();
}
